
import api from "./api";

const empresasService = {
  async listar() {
    const response = await api.get("/api/empresas");
    return response.data.empresas;
  },

  async cadastrar(dados) {
    const response = await api.post("/api/empresas", dados);
    return response.data;
  },

  async atualizar(id, dados) {
    // Laravel interpreta o POST como PUT.
    // Isso permite receber arquivos via multipart/form-data.
    dados.append("_method", "PUT");

    const response = await api.post(
      `/api/empresas/${id}`,
      dados
    );

    return response.data;
  },
};

export default empresasService;
